<template>
  <b-container fluid class='header'>
    <b-jumbotron fluid class='py-4'>
      <h1 class='mt-4'>Dashboard</h1>
      <p>Reports and analytics</p>
    </b-jumbotron>

    <b-container class="mt-2 main">
      <b-card-group deck class='mx-a'>
        <b-card class='mb-2 bg-primary-4 stat' title="Recipients">
          <h3>0</h3>
        </b-card>
        <b-card class='mb-2 bg-primary-5 stat' title="In progress">
          <h3>0</h3>
        </b-card>
        <b-card class='mb-2 bg-primary-1 stat' title="Finished">
          <h3>0</h3>
        </b-card>
        <b-card class='mb-2 bg-primary-2 stat' title="Replied">
          <h3>0</h3>
        </b-card>
        <!-- <b-card class='mb-2 bg-primary-3 stat' title="Bounced">
          <h3>0</h3>
        </b-card> -->
      </b-card-group>
      <b-card class='mt-2 mb-2'>
        Analytics coming soon
      </b-card>
      <!-- <h2>Getting started</h2>
      <p>Learn how to use Doli</p>
      <b-card>
        <p>Doli lets you create personalised videos automatically. You can add these to email sequences to deliver personalised video message to your prospects inboxes.</p>

        <h4>Clones</h4>
        <p>An clone is your personal avatar. In order to create your clone we have to learn to replicate your voice. You will need to record 15 minutes of voice data to let us do this. To start training go to <i>My clone > Train</i>.</p>
        <p>Once you have recorded it takes 24 hours to process your data before you can use your clone</p>

        <h4>Videos</h4>
        <p>Once you have created your clone you can create a template video. Record a video and replace the prospects name with "name" and the prospects company with "company". When you add recipients we will create a personalised video to the recipient replacing when you say "name" with their name.</p>
        <p>For each recipient you add we create a video and host it on a public link you can share. You can also add a call to action to show once the video is complete.</p>

        <h4>Sequences</h4>
        <p>A sequence is a series of emails sent to recipients. The sequence will stop sending once the recipient replies to an email. Once you have created a video you can create a sequence.</p>
        <p>You can add recipients to your sequence one at a time or batch uploading. You are limited by the number of recipients you can add each month by your plan.</p>
        <p>Emails are sent from your gmail account, you can connect this in <i>Settings</i>.</p>
      </b-card> -->
    </b-container>
  </b-container>
</template>

<script>

import { db } from '@/main.js'

export default {
  metaInfo: {title: 'Dashboard'},
  props: ['profile'],
  data() {
    return {

    }
  },
  methods: {

  },
  created() {
    this.$router.push({name: 'projects'})
  }
}
</script>

<style scoped>

.jumbotron {
  min-height: 200px;
}

</style>
